import { render, staticRenderFns } from "./ClientUsersPage.vue?vue&type=template&id=49cbd33c"
import script from "./ClientUsersPage.vue?vue&type=script&lang=js"
export * from "./ClientUsersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports